const enum LocalConstants {
  SportsOfferingBase = 'kambi-sports-offering',
}

export const sportsOfferingQueryKeys = {
  SportsOfferingBase: [LocalConstants.SportsOfferingBase],

  get BetOffersBase() {
    return [...this.SportsOfferingBase, 'bet-offers']
  },
  BetOffersByIds(betOfferIds: number[]) {
    return [...this.BetOffersBase, 'by-ids', ...betOfferIds]
  },
  BetOffersByEvents(eventIds: number[]) {
    return [...this.BetOffersBase, 'by-events', ...eventIds]
  },
  BetOffersByGroups(groupIds: number[]) {
    return [...this.BetOffersBase, 'by-groups', ...groupIds]
  },

  get ListViewBase() {
    return [...this.SportsOfferingBase, 'ListView']
  },
  get UpcomingEventsForAllSports() {
    return [...this.ListViewBase, 'upcoming', 'all-sports']
  },
  get LiveEventsForAllSports() {
    return [...this.ListViewBase, 'live', 'all-sports']
  },
  EventsForSport(sport: string, categoryId: number | undefined) {
    return [...this.ListViewBase, 'sport', sport, 'events', categoryId]
  },
  EventsForCompetition(sport: string, region: string, competition: string) {
    return [...this.ListViewBase, 'competition', sport, region, competition]
  },
  EventsForCompetitionMatches(
    sport: string,
    region: string,
    competition: string,
    categoryId?: number
  ) {
    return [...this.EventsForCompetition(sport, region, competition), 'matches', categoryId]
  },
  EventsForCompetitionFutures(sport: string, region: string, competition: string) {
    return [...this.EventsForCompetition(sport, region, competition), 'futures']
  },

  get GroupBase() {
    return [...this.SportsOfferingBase, 'groups']
  },
  get EventGroupsFromRoot() {
    return [...this.GroupBase, 'events-groups-from-root']
  },
  get EventGroupHighlights() {
    return [...this.GroupBase, 'highlight']
  },
  Group(groupId: number | null) {
    return [...this.GroupBase, 'group', groupId ?? 'null']
  },

  get EventsBase() {
    return [...this.SportsOfferingBase, 'events']
  },
  EventsForGroupId(groupId: number | null) {
    return [...this.EventsBase, 'group', groupId ?? 'null']
  },

  SgmAvailabilityForGroup: (groupId: number | null) => [
    LocalConstants.SportsOfferingBase,
    'group',
    groupId ?? 'null',
    'sgm-availability',
  ],

  SgmAvailabilityForEvent: (eventId: number | null) => [
    LocalConstants.SportsOfferingBase,
    'event',
    eventId ?? 'null',
    'sgm-availability',
  ],

  JerseysForEvent: (eventId: number | null) => [
    LocalConstants.SportsOfferingBase,
    'event',
    eventId ?? 'null',
    'jerseys',
  ],

  CashOutSpecialEventsForAllSports: [LocalConstants.SportsOfferingBase, 'events', 'cash-out'],

  EventPricingForEvent: (eventId: number | null) => [
    LocalConstants.SportsOfferingBase,
    'event',
    eventId ?? 'null',
    'pricing',
  ],

  ParticipantsByLeague: (competitionId: number) => [
    LocalConstants.SportsOfferingBase,
    'league',
    'participants',
    competitionId,
  ],
} as const

// cspell:ignore betoffers
